import { useFragment } from '@apollo/client';

import { useBrandSubscription } from '@hook/useBrandSubscription';
import { Skeleton } from '@ui/Skeleton';
import { ProductDetailsBrand } from '@components/product/ProductDetailsBrand';

import { ProductDetailsBrandFragment, ProductDetailsBrandFragmentDoc } from './gql/graphql.v5.generated';

interface Props {
  className?: string,
  productId: number,
}

export const ProductDetailsBrandContainer: React.FC<Props> = ({
  className,
  productId,
}) => {
  const { data: brandData, complete: brandDataComplete } = useFragment<ProductDetailsBrandFragment>({
    fragment: ProductDetailsBrandFragmentDoc,
    from: {
      __typename: 'ProductType',
      id: productId,
    },
  });

  const {
    loading: subscriptionLoading,
    handleSubscribe,
    handleUnsubscribe,
  } = useBrandSubscription();

  const handleToggleSubscription = () => {
    if (brandDataComplete && brandData.brand) {
      if (brandData?.brand?.isViewerSubscribed) {
        handleUnsubscribe({
          brandId: brandData?.brand.id,
        });
      } else {
        handleSubscribe({
          brandId: brandData?.brand.id,
        });
      }
    }
  };

  if (!brandDataComplete) {
    return (
      <div className={className}>
        <Skeleton
          height='16px'
          width='120px'
        />
      </div>
    );
  }

  if (brandData.brand) {
    return (
      <ProductDetailsBrand
        className={className}
        brand={brandData.brand}
        isSubscriptionLoading={subscriptionLoading}
        onToggleSubscription={handleToggleSubscription}
      />
    );
  }

  return null;
};
